module.exports = __webpack_public_path__ + "static/media/circle-shape-locket-print.98ba1230.png";